
import { colors as themeColors } from '../../../utils/theme';
import { TextField, FormControl, FormControlLabel, Radio, RadioGroup, MenuItem, Select, InputLabel, Box, Stack, FormLabel, } from "@mui/material";
import CitySearchInput from "../../../components/CitySearchInput";
import dayjs from "dayjs";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const applyForOptions = ["Sales Executive", "Telecaller", "Field Sales", "Customer Support Executive", "Backend Developer", "Other"];

export default function HRPersonalDetails({ formData, setFormData, city, setCity, stateField, setStateField, country, setCountry, cities, errors, handleChange, connectionString, }) {

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    // ✅ VALIDATION HELPER FUNCTIONS
    const isMobileValid = (mobile) => {
        if (!mobile || mobile.length === 0) return true; // Empty is OK (will be caught by required)
        return mobile.length === 10;
    };

    const isEmailValid = (email) => {
        if (!email || email.length === 0) return true; // Empty is OK
        return email.includes('@') && email.includes('.');
    };

    const isPincodeValid = (pincode) => {
        if (!pincode || String(pincode).length === 0) return true; // Empty is OK
        return String(pincode).length === 6;
    };

    return (
        <>
            <Stack spacing={2}>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <TextField label="Name" size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, minWidth: 280, height: 40 }} required value={formData.name} onChange={handleChange("name")} />
                    <TextField label="Email ID" size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, minWidth: 280, height: 40 }} required value={formData.emailId} onChange={handleChange("emailId")} error={!isEmailValid(formData.emailId)} helperText={!isEmailValid(formData.emailId) ? "Email must contain @ and ." : ""} />
                </Box>

                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Box sx={{ display: "flex", gap: 1, flex: 1 }}>
                        <Box sx={{ display: "flex", flex: 1 }}>
                            <TextField label="Mobile No." size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, height: 40 }} required value={formData.mobileNo} onChange={e => setFormData(p => ({ ...p, mobileNo: e.target.value.replace(/\D/g, "").slice(0, 10) }))} error={!isMobileValid(formData.mobileNo)} helperText={!isMobileValid(formData.mobileNo) ? "Mobile must be exactly 10 digits" : ""} />
                        </Box>
                        <Box sx={{ display: "flex", flex: 1 }}>
                            <DatePicker label="Date of Birth" value={formData.dob ? dayjs(formData.dob) : null} onChange={(newValue) => setFormData(p => ({ ...p, dob: newValue ? newValue.format("YYYY-MM-DD") : "" }))} format="DD/MM/YYYY" slotProps={{
                                textField: {
                                    size: "small", fullWidth: true, required: true, InputLabelProps: {
                                        sx: {
                                            "& .MuiFormLabel-asterisk": {
                                                color: themeColors.error.dark, // 🔴 red star
                                            },
                                        },
                                    },
                                }
                            }} />
                        </Box>
                    </Box>
                    <FormControl size="small" required sx={{ flex: 1, minWidth: 280 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <FormLabel
                                required
                                sx={{
                                    minWidth: 60,
                                    '& .MuiFormLabel-asterisk': {
                                        color: themeColors.error.dark, // 🔴 red star
                                    },
                                }}
                            >
                                Gender
                            </FormLabel>

                            <RadioGroup row value={formData.gender} onChange={handleChange("gender")} >
                                <FormControlLabel value="Male" control={<Radio size="small" />} label="Male" />
                                <FormControlLabel value="Female" control={<Radio size="small" />} label="Female" />
                                <FormControlLabel value="Other" control={<Radio size="small" />} label="Other" />
                            </RadioGroup>
                        </Box>
                    </FormControl>
                </Box>

                <Box sx={{ display: "flex", gap: 1, flex: 1 }}>
                    <Box sx={{ display: "flex", flex: 1 }}>
                        <TextField label="Address" size="small" multiline minRows={3.1} value={formData.address} onChange={handleChange("address")} required fullWidth InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-input': { overflow: 'hidden !important', resize: 'none', }, }} />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, gap: 1 }}>
                        <Box sx={{ display: "flex", flex: 1, gap: 1 }}>
                            <Box flex={0.4}>
                                <TextField label="PIN Code" size="small" value={formData.pinCode} onChange={(e) => setFormData(p => ({ ...p, pinCode: e.target.value.replace(/\D/g, "").slice(0, 6) }))} fullWidth required InputLabelProps={{ sx: requiredAsteriskStyle }} error={!isPincodeValid(formData.pinCode)} helperText={!isPincodeValid(formData.pinCode) ? "Pincode must be exactly 6 digits" : ""} />
                            </Box>
                            <Box flex={0.6}>
                                <CitySearchInput value={city} cities={cities} fullWidth connectionString={connectionString} onSelectCity={(c) => { setCity(c.city); setStateField(c.state); setCountry(c.country); }} />
                            </Box>
                        </Box>
                        <Box display="flex" flex={1} gap={1}>
                            {/* State - 66% of the row (i.e., 2/3) */}
                            <Box flex={0.6}>
                                <TextField label="State" name="state" value={stateField} size="small" disabled required fullWidth InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root': { height: 40, }, '& .MuiInputLabel-root': { lineHeight: '1.2em', }, }} />
                            </Box>

                            <Box flex={0.4}>
                                {/* <TextField label="State Code" name="stateCode" value={stateCode} size="small" disabled fullWidth sx={{ '& .MuiInputBase-root': { height: 40, }, '& .MuiInputLabel-root': { lineHeight: '1.2em', }, }} /> */}
                                <TextField label="Country" fullWidth size="small" disabled value={country} required InputLabelProps={{ sx: requiredAsteriskStyle }} onChange={(e) => setCountry(e.target.value)} />
                            </Box>
                        </Box>
                    </Box>
                </Box>


                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Box display="flex" flex={1} gap={1}>
                        <FormControl sx={{ flex: 0.6 }} size="small" >
                            <InputLabel id="apply-for-label" required sx={{
                                '& .MuiFormLabel-asterisk': {
                                    color: themeColors.error.dark, // 🔴 red star
                                },
                            }}>Apply For</InputLabel>
                            <Select labelId="apply-for-label" label="Apply For" value={formData.applyFor} onChange={handleChange("applyFor")} >
                                {applyForOptions.map(o => (
                                    <MenuItem key={o} value={o}>{o}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box display="flex" flex={0.4}>
                            <DatePicker label="Date of Application" value={formData.dateOfApplication ? dayjs(formData.dateOfApplication) : null} onChange={(newValue) => setFormData(p => ({ ...p, dateOfApplication: newValue ? newValue.format("YYYY-MM-DD") : "" }))} format="DD/MM/YYYY" slotProps={{
                                textField: {
                                    size: "small", fullWidth: true, required: true, InputLabelProps: {
                                        sx: {
                                            "& .MuiFormLabel-asterisk": {
                                                color: themeColors.error.dark, // 🔴 red star
                                            },
                                        },
                                    },
                                }
                            }} />
                        </Box>
                    </Box>
                    <Box display="flex" flex={1} gap={1}>
                        <TextField label="Native Place" size="small" sx={{ flex: 0.6, minWidth: 280 }} value={formData.nativePlace} onChange={handleChange("nativePlace")} />
                        <TextField label="Alternate Mobile No. (Optional)" size="small" value={formData.altMobileNo} onChange={(e) => setFormData(p => ({ ...p, altMobileNo: e.target.value.replace(/\D/g, "").slice(0, 10) }))} sx={{ flex: 0.4 }} fullWidth error={formData.altMobileNo && formData.altMobileNo.length > 0 && formData.altMobileNo.length !== 10} helperText={formData.altMobileNo && formData.altMobileNo.length > 0 && formData.altMobileNo.length !== 10 ? "Mobile must be exactly 10 digits" : ""} />
                    </Box>
                </Box>

                {formData.applyFor === "Other" && (
                    <TextField label="Apply For (Other)" size="small" fullWidth required value={formData.applyForOther} onChange={handleChange("applyForOther")} placeholder="Enter applied position" />
                )}

                <Box display="flex" flex={1} gap={1}>
                    <FormControl size="small" fullWidth>
                        <InputLabel
                            required
                            sx={{
                                '& .MuiFormLabel-asterisk': {
                                    color: themeColors.error.dark, // 🔴 red star
                                },
                            }}
                        >
                            Marital Status
                        </InputLabel>
                        <Select label="Marital Status" value={formData.maritalStatus} onChange={handleChange("maritalStatus")} required >
                            <MenuItem value="Single">Single</MenuItem>
                            <MenuItem value="Married">Married</MenuItem>
                            <MenuItem value="Divorced">Divorced</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl size="small" fullWidth>
                        <InputLabel>Blood Group (Optional)</InputLabel>
                        <Select label="Blood Group (Optional)" value={formData.bloodGroup} onChange={handleChange("bloodGroup")} >
                            {["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"].map(bg => (
                                <MenuItem key={bg} value={bg}>{bg}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                {/* {formData.maritalStatus === "Married" && (
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <TextField label="Spouse Name" size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, minWidth: 280 }} value={formData.spouseName} onChange={handleChange("spouseName")} required />
                        <TextField label="Spouse Contact No." size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, minWidth: 280 }} value={formData.spouseContact} onChange={(e) => setFormData(p => ({ ...p, spouseContact: e.target.value.replace(/\D/g, "").slice(0, 10) }))} required error={formData.spouseContact && formData.spouseContact.length > 0 && formData.spouseContact.length !== 10} helperText={formData.spouseContact && formData.spouseContact.length > 0 && formData.spouseContact.length !== 10 ? "Contact must be exactly 10 digits" : ""} />
                    </Box>
                )}  */}

                {/* <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    <TextField label="Father Name (Optional)" size="small" sx={{ flex: 1, minWidth: 280 }} value={formData.fatherName} onChange={handleChange("fatherName")} />
                    <TextField label="Father Contact No. (Optional)" size="small" sx={{ flex: 1, minWidth: 280 }} value={formData.fatherContact} onChange={(e) => setFormData(p => ({ ...p, fatherContact: e.target.value.replace(/\D/g, "").slice(0, 10) }))} error={formData.fatherContact && formData.fatherContact.length > 0 && formData.fatherContact.length !== 10} helperText={formData.fatherContact && formData.fatherContact.length > 0 && formData.fatherContact.length !== 10 ? "Contact must be exactly 10 digits" : ""} />
                </Box>

                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    <TextField label="Mother Name (Optional)" size="small" sx={{ flex: 1, minWidth: 280 }} value={formData.motherName} onChange={handleChange("motherName")} />
                    <TextField label="Mother Contact No. (Optional)" size="small" sx={{ flex: 1, minWidth: 280 }} value={formData.motherContact} onChange={(e) => setFormData(p => ({ ...p, motherContact: e.target.value.replace(/\D/g, "").slice(0, 10) }))} error={formData.motherContact && formData.motherContact.length > 0 && formData.motherContact.length !== 10} helperText={formData.motherContact && formData.motherContact.length > 0 && formData.motherContact.length !== 10 ? "Contact must be exactly 10 digits" : ""} />
                </Box> */}

                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    <TextField label="Source" size="small" required InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ flex: 1, minWidth: 280 }} value={formData.source} onChange={handleChange("source")} error={errors.source} helperText={errors.source ? "Source is required" : ""} />
                    <TextField label="Reference By (Optional)" size="small" sx={{ flex: 1, minWidth: 280 }} value={formData.referenceBy} onChange={handleChange("referenceBy")} />
                </Box>

            </Stack>
        </>
    );
}